import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface DashboardChartProps {
  totalStudents: number;
  pendingLeases: number;
  outstandingInvoices: number;
}

const DashboardChart: React.FC<DashboardChartProps> = ({
  totalStudents,
  pendingLeases,
  outstandingInvoices,
}) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Housing Statistics',
      },
    },
  };

  const data = {
    labels: ['Total Students', 'Pending Leases', 'Outstanding Invoices'],
    datasets: [
      {
        label: 'Count',
        data: [totalStudents, pendingLeases, outstandingInvoices],
        backgroundColor: [
          'rgba(53, 162, 235, 0.5)',
          'rgba(255, 159, 64, 0.5)',
          'rgba(255, 99, 132, 0.5)',
        ],
      },
    ],
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <Bar options={options} data={data} />
    </div>
  );
};

export default DashboardChart;